import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import DoubleRightIcon from '../../../assets/icons/JSX/DoubleRightIcon'
import Colors from '../../../assets/styles/Colors'
import { Container } from '../../../assets/styles/GlobalStyle'
import LeftThreeDot from '../../../assets/v2/JSX/LeftThreeDot'
import CompanySelect from '../../../components/v2/CompanySelect'
import Dropdown from '../../../components/v2/Dropdown'
import RightThreeDot from '../../../assets/v2/JSX/RightThreeDot'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import { useNavigate } from 'react-router-dom'
import GreenTick from '../../../assets/v2/JSX/GreenTick'
import RedCross from '../../../assets/v2/JSX/RedCross'
import { useAppDispatch, useAppSelector } from '../../../store'
import {
  CriticalIllnessState,
  setCurrency,
  setLimit,
  setOffer,
  setPaymentScheduleInfo,
} from '../../../store/criticalIllnessSlice'
import MovingPrice from '../../../components/v2/MovingPrice'
import ToggleSwitcher from '../../../components/v2/buttons/ToggleSwitcher'
import dayjs from 'dayjs'
import CriticalProgressbar from '../../../components/v2/progrees-bars/CriticalProgressbar'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import { currencySymbol } from '../../../domain/types'
import api from '../../../api'
import Loader from '../../../components/Loader'
import { AppState } from '../../../store/appSlice'
//
//
const CriticalOffer = () => {
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const dispatch = useAppDispatch()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { filter, screenHeader } = useAppSelector((data: { critical: CriticalIllnessState }) => data.critical)
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetPetPageInfoQuery('critical-best-offer')
  //
  const pageTitle = pageInfo?.translations?.[lang]?.title
  const stepName = pageInfo?.translations?.[lang]?.stepName
  //
  const MainOffer = filter.offer
  //
  const fakeData = {
    translations: {
      ge: {
        stepName: 'შეთავაზება',
      },
      en: {
        stepName: 'offer',
      },
    },
    currencies: [
      {
        id: 1,
        type: 'gel',
        title: 'GEL',
        translations: {
          ge: {
            title: 'ლარი',
          },
          en: {
            title: 'GEL',
          },
        },
      },
      {
        id: 2,
        type: 'usd',
        title: 'USD',
        translations: {
          ge: {
            title: 'დოლარი',
          },
          en: {
            title: 'USD',
          },
        },
      },
      {
        id: 3,
        type: 'eur',
        title: 'EUR',
        translations: {
          ge: {
            title: 'ევრო',
          },
          en: {
            title: 'EUR',
          },
        },
      },
    ],
    limits: [
      {
        id: 1,
        value: 20000,
      },
      {
        id: 2,
        value: 25000,
      },
    ],
    covered: {
      aldagi: [
        {
          id: 1,
          body: 'პროდუქტი უზრუნველყოფს ერთიანი თანხის გაცემას კრიტიკული დაავადების გამოვლენის შემთხვევაში',
        },
        {
          id: 2,
          body: 'დაზღვევის დეტალურ პირობებს და კონკრეტულ დაავადებებთან დაკავშირებულ მნიშვნელოვან ინფორმაციას გაეცანით ხელშეკრულებაში',
        },
        {
          id: 3,
          body: 'ყურადღება გაამახვილეთ ხელშეკრულებით განსაზღვრულ გამონაკლის შემთხვევებზე',
        },
        {
          id: 4,
          body: 'ყურადღება გაამახვილეთ იმ სერვისებზე რომელზეც ვრცელდება მოცდის პერიოდი',
        },
        {
          id: 5,
          body: 'მოცდის პერიოდი - ის პერიოდი რომლის განმავლობაშიც კონკრეტული სამედიცინო მომსახურების ხარჯები არ ანაზღაურდება',
        },
        {
          id: 6,
          body: 'საჭიროების შემთხვევაში შეგიძლიათ დაუკავშირდეთ კომპანია ალდაგს ცხელ ხაზზე: +995 322 444 999',
        },
      ],
      ardi: [
        {
          id: 1,
          body: 'პროდუქტი უზრუნველყოფს ერთიანი თანხის გაცემას კრიტიკული დაავადების გამოვლენის შემთხვევაში',
        },
        {
          id: 2,
          body: 'დაზღვევის დეტალურ პირობებს და კონკრეტულ დაავადებებთან დაკავშირებულ მნიშვნელოვან ინფორმაციას გაეცანით ხელშეკრულებაში',
        },
        {
          id: 3,
          body: 'ყურადღება გაამახვილეთ ხელშეკრულებით განსაზღვრულ გამონაკლის შემთხვევებზე',
        },
        {
          id: 4,
          body: 'ყურადღება გაამახვილეთ იმ სერვისებზე რომელზეც ვრცელდება მოცდის პერიოდი',
        },
        {
          id: 5,
          body: 'მოცდის პერიოდი - ის პერიოდი რომლის განმავლობაშიც კონკრეტული სამედიცინო მომსახურების ხარჯები არ ანაზღაურდება',
        },
        {
          id: 6,
          body: 'საჭიროების შემთხვევაში შეგიძლიათ დაუკავშირდეთ კომპანია არდს ცხელ ხაზზე: +995 322 10 10 10',
        },
      ],
    },
  }
  //
  const currencies = fakeData.currencies
  //
  const limits = fakeData.limits
  //
  //
  // ###############
  const [scrollPosition, setScrollPosition] = useState(0)
  const handleScroll = () => {
    const position = window.pageYOffset
    setScrollPosition(position)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  })
  // ###############
  //
  const MainLoading = isPageInfoLoading
  //
  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={pageTitle} />

        <CriticalProgressbar stepName={stepName} />

        <Schedule>
          <span
            style={{
              color: filter.paymentSchedule?.id === 1 ? Colors.nevadaGrey : Colors.primaryBlack,
            }}
          >
            {t('monthly')}
          </span>
          <ToggleSwitcherStyle
            activeRedBackground={true}
            defaultValue={filter.paymentSchedule?.type === 'MONTHLY' ? false : true}
            onChange={(value) => {
              if (value === true) {
                return [
                  dispatch(
                    setPaymentScheduleInfo({
                      id: 1,
                      type: 'ONE-TIME',
                    }),
                  ),
                ]
              } else {
                return [
                  dispatch(
                    setPaymentScheduleInfo({
                      id: 2,
                      type: 'MONTHLY',
                    }),
                  ),
                ]
              }
            }}
          />
          <span
            style={{
              color: filter.paymentSchedule?.id === 2 ? Colors.nevadaGrey : Colors.primaryBlack,
            }}
          >
            {t('annual')}
          </span>
        </Schedule>

        {scrollPosition >= 300 && (
          <MovingPrice
            price={
              filter.paymentSchedule?.type === 'MONTHLY'
                ? MainOffer?.calculatedPrices.monthly
                : MainOffer?.calculatedPrices.annual
            }
          />
        )}
        <Price>
          <LeftThreeDot />
          <div>
            {filter.paymentSchedule?.type === 'MONTHLY'
              ? `${MainOffer?.calculatedPrices.monthly} ₾`
              : `${MainOffer?.calculatedPrices.annual} ₾`}
          </div>
          <RightThreeDot />
        </Price>

        <Block>
          <OfferTitle>{`${t('see')} ${MainOffer?.brandName?.[lang]?.title}${t('seeCompanyOffer')} `}</OfferTitle>
          <OfferDescription>{t('youCanChooseOtherCompany')}</OfferDescription>

          <br />
          <CompanySelect
            closeMenuOnSelect={true}
            onChange={(data) => {
              if (data.value) {
                return dispatch(setOffer(filter.companyOffers?.find((x) => x.companyId === data.value)))
              }
            }}
            title={t('changeCompany')}
            isMulti={false}
            maxSelectLenght={3}
            maxSelectText={`${t('companyCmpare')}`}
            placeholder={t('selectCompanies')}
            value={MainOffer?.companyId}
            showInnerPrice={true}
            showOptionCheckmark={true}
            options={filter.companyOffers?.map((item) => ({
              value: item.companyId,
              label: item.brandName?.[lang]?.title,
              imgUrl: item.companyLogo,
              price: item.calculatedPrices.monthly,
            }))}
          />
          <br />

          <AddonsTitle>{t('youCanChange')}</AddonsTitle>

          <DropdownWrapper>
            <Dropdown
              value={filter.currency || ''}
              title={`${t('currency')}`}
              options={currencies.map((x) => ({
                value: x.type,
                label: x.title?.toUpperCase(),
              }))}
              onChange={(obj) => dispatch(setCurrency(obj.value))}
            />

            <Dropdown
              value={filter.limit || ''}
              title={`${t('limit')}`}
              options={limits.map((x) => ({
                value: x.value,
                label:
                  x?.value?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
                  ` ${currencySymbol(filter.currency || 'gel')}`,
              }))}
              onChange={(obj) => dispatch(setLimit(Number(obj.value)))}
            />
          </DropdownWrapper>

          <HR />

          <ServicesBlock>
            <ServicesTitle>{t('service')}</ServicesTitle>

            {MainOffer?.services?.map((service, index) => (
              <TextDiv key={index}>
                <LeftText>{service.title}</LeftText>
                <RightText>{service.covered === true ? <GreenTick /> : <RedCross />}</RightText>
              </TextDiv>
            ))}
          </ServicesBlock>
          <HR />

          <ServicesBlock>
            <TextDiv>
              <LeftText>{t('policyDuration')}</LeftText>
              <RightText>{parseInt(filter.chooseDays ? filter?.chooseDays : '1') * 12 + ' ' + t('month')}</RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('startDate')}</LeftText>
              <RightText>{filter.dates?.start ? dayjs(filter.dates?.start).format('DD MMMM YYYY') : ''}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('endDate')}</LeftText>
              <RightText>{filter.dates?.end ? dayjs(filter.dates?.end).format('DD MMMM YYYY') : ''}</RightText>
            </TextDiv>
          </ServicesBlock>

          <HR />

          <ServicesBlock>
            <TextDiv>
              <LeftText>{t('paymentSchedule')}</LeftText>
              <RightText>{filter.paymentSchedule?.type === 'MONTHLY' ? `${t('monthly')}` : `${t('annual')}`}</RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('currentPayment')}</LeftText>
              <RightText>{MainOffer?.calculatedPrices.monthly} ₾</RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('eachPayment')}</LeftText>
              <RightText>{MainOffer?.calculatedPrices?.monthly} ₾</RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('totalAmount')}</LeftText>
              <RightText>{MainOffer?.calculatedPrices?.annual} ₾</RightText>
            </TextDiv>
          </ServicesBlock>

          <HR />

          <PriceWrapper>
            <PriceText>
              {filter.paymentSchedule?.type === 'MONTHLY'
                ? `${MainOffer?.calculatedPrices.monthly} ₾/${t('month')}`
                : `${MainOffer?.calculatedPrices.annual} ₾`}
            </PriceText>
            <ATagStyle href={''} target="_blank">
              <div>{t('policyTerms')}</div>
            </ATagStyle>
          </PriceWrapper>
        </Block>

        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => {
              if (filter.chooseMethod === 'frani-choice') {
                navigate('/critical-choose-method')
              } else if (filter.chooseMethod === 'my-choice') {
                navigate('/critical-offers')
              } else {
                navigate('/critical-choose-method')
              }
            }}
          />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={false}
            onClick={() => [navigate('/critical-who-do-you-insure')]}
          />
        </Buttons>
      </Content>

      <Container>
        <MessageBox>
          <MessageContent>
            <MessageHead>
              <span>{t('notCovered')}</span>
            </MessageHead>
            {MainOffer?.companySlug &&
              // @ts-ignore
              fakeData?.covered[MainOffer?.companySlug]?.map((item: any) => (
                <MessageText key={item.id}>
                  <DoubleRightIcon /> <span>{item.body}</span>
                </MessageText>
              ))}
          </MessageContent>
        </MessageBox>
      </Container>

      {scrollPosition <= 0 && <BackgroundIcon />}
    </Wrapper>
  )
}
//
const PriceText = styled.div`
  font-size: 28px;
  color: ${Colors.primaryBlack};
  text-decoration: none;
  font-weight: bold;

  ${Responsive.mobile} {
    font-size: 24px;
  }
`
const ATagStyle = styled.a`
  font-size: 14px;
  line-height: 18px;
  color: ${Colors.primaryBlack};
  text-align: right;
  font-weight: 500;
  padding-inline: 2px;
  text-decoration: underline;

  &:hover {
    color: ${Colors.primaryBlack};
  }
`
const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
`
const ServicesBlock = styled.div`
  display: flex;
  flex-direction: column;
`
const RightText = styled.div`
  text-align: right;
`
const LeftText = styled.div`
  width: 70%;
`
const TextDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${Colors.nevadaGrey};
  font-size: 14px;
  &:not(:last-child) {
    margin-bottom: 14px;
  }
`
const ServicesTitle = styled.h6`
  font-size: 14px;
  color: ${Colors.primaryBlack};
`

const Schedule = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block: 32px;

  span {
    font-size: 18px;
    line-height: 17px;
    color: ${Colors.primaryBlack};
    :first-child {
      padding-right: 10px;
    }
    :last-child {
      padding-left: 10px;
    }
  }
  svg {
    color: ${Colors.secondaryGrey};
  }

  ${Responsive.mobile} {
    margin-block: 24px;
  }
`
const ToggleSwitcherStyle = styled(ToggleSwitcher)`
  label {
    margin-left: 20px;
  }
`
const MessageText = styled.div`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  /*  */
  &:last-child {
    margin-bottom: 0px;
  }

  /* message text span */
  span {
    margin-left: 15px;
    color: ${Colors.primaryGrey};
  }

  /* message checkmark icon & svg */
  svg {
    min-width: 20px;
    width: 20px;
    height: 20px;
    margin-left: -3px;
    color: ${Colors.primaryGrey};
  }

  /*  */
  ${Responsive.mobile} {
    /* message checkmark icon & svg */
    svg {
      margin-left: 0px;
      min-width: 15px;
      width: 15px;
    }

    /* message text span */
    span {
      margin-left: 20px;
      color: ${Colors.primaryGrey};
      line-height: 20px;
    }
  }
`
const MessageHead = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  display: flex;
  align-items: center;
  margin-bottom: 18px;

  ${Responsive.mobile} {
    font-size: 14px;
    margin-bottom: 15px;

    /* message text span */
    span {
      margin-left: 15px;
    }
  }
`
const MessageContent = styled.div`
  margin-bottom: 33px;
`
const MessageBox = styled.div`
  :first-child {
    border-top: 1px solid ${Colors.secondaryGrey};
    margin-top: 80px;
  }
  padding-top: 30px;
  ${Responsive.tablet} {
    max-width: 700px;
    margin: 0 auto;
  }
`

const HR = styled.hr`
  margin-block: 24px;
`
const DropdownWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 3rem 3rem;
  ${Responsive.laptop} {
    gap: 2rem 2rem;
  }
  ${Responsive.tablet} {
    gap: 2rem 2rem;
  }
  ${Responsive.mobile} {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 1rem 2rem;
  }
`
const OfferDescription = styled.h6`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
`
const OfferTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  span {
    font-weight: bold;
  }
  ${Responsive.mobile} {
    font-size: 14px;
  }
`

const AddonsTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 20px;
`
const Price = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
  user-select: none;
  pointer-events: none;
  /* text */
  div {
    height: 64px;
    background-color: ${Colors.primaryRed};
    border-radius: 40px;
    color: ${Colors.white};
    font-size: 20px;
    padding-inline: 40px;
    margin-inline: 10px;
    display: grid;
    place-items: center;
    box-shadow: 0 4px 35px 0 rgba(254, 95, 85, 0.32);
  }
  svg {
    height: 64px;
  }
  /* Responsive */
  ${Responsive.mobile} {
    div {
      height: 40px;
      font-size: 18px;
      font-weight: bold;
      padding-inline: 23px;
      margin-inline: 0px;
    }
    svg {
      height: 40px;
    }
  }
`
const Block = styled.div`
  max-width: 800px;
  width: 100%;
  padding: 48px;
  background-color: ${Colors.white};
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  margin-block: 48px;
  border-radius: 8px;

  ${Responsive.mobile} {
    margin-block: 33px;
    padding: 20px;
    width: calc(100vw - 40px);
  }
`

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  width: min-content;
  margin-top: 48px;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`

const Content = styled.div`
  width: 100%;
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  position: relative;
`
//
export default CriticalOffer
